// Static placeholder copy — to be replaced by final wording / managed texts in a later story.
export const FAST_TRACK_DIALOG_TEXTS = {
  title: 'Fast-track process available',
  intro: 'This assessment is eligible for the Fast-track process. Please review the company advice below and decide how to proceed.',
  explanation:
    'By continuing with Fast-track you confirm that you have reviewed the advice. Declining keeps the standard High-risk process. Your decision cannot be changed afterwards.',
  confirmationLabel: 'I confirm that the company risks are not material to the transaction.',
  continueLabel: 'Continue with Fast-track',
  declineLabel: 'Decline',
} as const;

export const FAST_TRACK_LOAD_ERROR_MESSAGE = 'Fast-track details could not be loaded. Please reload the page to try again.';

/** HTTP statuses after which a retry cannot succeed (decision already made, expired, not author, feature disabled). */
export const FAST_TRACK_TERMINAL_STATUSES: readonly number[] = [403, 404, 409];

// Static placeholder — to be replaced by configurable rich text managed in Admin in a later story.
export const FAST_TRACK_INFO_DIALOG_TEXTS = {
  title: 'Fast-track due diligence',
  paragraphs: [
    'The following is a preliminary informational text that is shown after Fast-Track process has been confirmed by the Underwriter. This text is not final and should be treated as a test solution.',
    'The Underwriter has confirmed that the allegations covered by the Fast-track Advice (Company and Country/Sector advices) are not material to the assessed transaction.',
    'The subsequent due-diligence process should be treated according to the Medium-risk process.',
    'The Underwriter must review the additional ESG information for new or additional material allegations.',
    'Allegations already covered by the Fast-track confirmation should not by themselves result in a referral.',
    'If new material allegations are identified, the Underwriter must decide whether to abstain or create a referral if they still intend to write the business.',
  ],
  nextLabel: 'Next',
} as const;
